import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { combineLatest, Observable } from 'rxjs';
import { first, map } from 'rxjs/operators';

import { AuthService } from '@app/core/auth.service';
import { FeatureFlagSelectors } from '@app/core/feature-flags/feature-flag.selectors';
import { FeatureFlags } from '@app/core/feature-flags/feature-flags';

import { UserService } from '../../core/user.service';
import { ServiceArea } from '../service-area';
import { ServiceAreaService } from '../service-area.service';

@Component({
  selector: 'om-service-area-select',
  templateUrl: './service-area-select.component.html',
  styleUrls: ['./service-area-select.component.scss'],
})
export class ServiceAreaSelectComponent implements OnInit {
  @Input() additionalClasses: String;
  @Input() selectedServiceArea: ServiceArea;
  @Input() allowVirtualServiceAreas = true;
  @Input() excludeEnterpriseLocations = false;
  @Input() b2bId: number = null;

  @Output() selectedServiceAreaChanged = new EventEmitter<ServiceArea>();

  currentSelection: ServiceArea;
  excludedServiceAreas: string[];
  serviceAreas$: Observable<ServiceArea[]>;

  constructor(
    public serviceAreaService: ServiceAreaService,
    private userService: UserService,
    private authService: AuthService,
    private featureFlagSelectors: FeatureFlagSelectors,
  ) {}

  ngOnInit() {
    this.serviceAreas$ = this.allowVirtualServiceAreas
      ? this.serviceAreaService.allServiceAreaOptions$
      : this.serviceAreaService.nonVirtualServiceAreaOptions$;

    // Filter service areas based on excludeEnterpriseLocations flag
    if (this.excludeEnterpriseLocations) {
      this.featureFlagSelectors
        .getFeatureFlag(FeatureFlags.CONSUMER_REGISTRATION_SERVICE_AREA_ADULT_EXCLUSIONS, [])
        .subscribe(excludedServiceAreaCodes => {
          this.excludedServiceAreas = excludedServiceAreaCodes;
        });
      this.serviceAreas$ = this.serviceAreas$.pipe(
        map(serviceAreas => serviceAreas.filter(sa => !this.excludedServiceAreas.includes(sa.code))),
      );
    }

    if (this.authService.isLoggedIn()) {
      combineLatest([this.userService.user$, this.serviceAreas$])
        .pipe(first())
        .subscribe(([user, serviceAreas]) => {
          let initialSelectedServiceArea: ServiceArea;
          if (this.selectedServiceArea != null) {
            initialSelectedServiceArea = serviceAreas.find(sa => sa.id === this.selectedServiceArea.id);
          } else if (user != null && user.serviceArea != null) {
            initialSelectedServiceArea = serviceAreas.find(sa => sa.id === user.serviceArea.id);
          }
          if (initialSelectedServiceArea) {
            this.currentSelection = initialSelectedServiceArea;
            this.selectedServiceAreaChanged.emit(this.currentSelection);
          }
        });
      this.userService.getUser();
    }
    this.serviceAreaService.getServiceAreas(this.b2bId);
  }

  setSelectedServiceArea(serviceArea: ServiceArea) {
    // In cypress, sometimes an undefined service area is selected somehow, which should not be possible
    if (serviceArea) {
      this.currentSelection = serviceArea;
      this.selectedServiceAreaChanged.emit(serviceArea);
    }
  }
}
